import { render, staticRenderFns } from "./StudentCreditDetail.vue?vue&type=template&id=3a21ccb0&scoped=true&"
import script from "./StudentCreditDetail.vue?vue&type=script&lang=js&"
export * from "./StudentCreditDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a21ccb0",
  null
  
)

export default component.exports